import { memo } from "react";
import { Grid } from "@mui/material";

// Types
import { IDepartment } from "@/DataPages/types/timeAndPayRates/models";

// Components
import PayRatesAndPtoSkeleton from "@/DataPages/layouts/TimeAndPayRates/PayRatesAndPtoSkeleton";
import Department from "@/DataPages/layouts/TimeAndPayRates/Department";

type TSectionDepartmentsProps = {
	loading: boolean;
	isDataPresent: boolean;
	data: IDepartment[];
	searchValue: string;
	renderOption: "payRates" | "pto" | "timecard";
	generateKey: (value: string) => string;
};

export const SectionDepartments = memo((props: Readonly<TSectionDepartmentsProps>) => {
	const { loading, isDataPresent, data, searchValue, renderOption, generateKey } = props;

	return (
		<>
			{loading ? (
				<PayRatesAndPtoSkeleton />
			) : (
				<>
					{isDataPresent && (
						<Grid container item mt={0} rowSpacing={2}>
							{data.map((item) => {
								if (!item.listPositions?.length) {
									return null;
								}
								return (
									<Department
										key={generateKey(item.department)}
										content={item}
										searchValue={searchValue}
										renderOption={renderOption}
									/>
								);
							})}
						</Grid>
					)}
				</>
			)}
		</>
	);
});
